import { useContext } from "react"
import { AuthContext } from "../../../context/Authcontext"
import './profile.css'
export const Profile = () =>{

    const { userInfo } = useContext(AuthContext)

    if (!userInfo) return null;

    console.log(userInfo);

    const expirationDate = new Date(userInfo.activeEnrollment.expirationDate);
    const yyyy = expirationDate.getFullYear();
    let mm = expirationDate.getMonth() + 1; // Months start at 0!
    let dd = expirationDate.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;

    const formattedDate = dd + '/' + mm + '/' + yyyy;
    return (<>           
<div className="d-flex justify-content-center">
<div className="card mx-md-5 mt-5 w-75">
                <div className="card-header">
                    <h2 className="text-center">Mi Perfil</h2>
                </div>
                <div className="card-body">
                    <h3>Datos personales</h3>
                    <div className="text-start mb-4">
                        <p className="mb-1"><span className="text-heading fw-semibold">Nombre: </span>{`${userInfo?.name} ${userInfo?.lastname}`}</p>
                        <p className="mb-1"><span className="text-heading fw-semibold">Email: </span>{userInfo?.email}</p>
                        <p className="mb-1"><span className="text-heading fw-semibold">Teléfono: </span>{userInfo?.phoneNumber}</p>
                        <p className="mb-1"><span className="text-heading fw-semibold">N° Documento: </span>{userInfo?.dni}</p>
                    </div>

                    <h3>Datos de membresía</h3>
                    <div className="text-start mb-4">
                        <p className="mb-1"><span className="text-heading fw-semibold">Código de miembro: </span>{userInfo?.cardcode}</p>
                        <p className="mb-1"><span className="text-heading fw-semibold">Fecha de expiración actual: </span>{formattedDate}</p>
                    </div>
                </div>
            </div>
</div>
            
        </>)
}